import React, { Component } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import moment from "moment"

//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import {
  Button, Card, CardBody, Col, Container, Row, FormGroup,
  ModalHeader, ModalBody, Spinner, Modal, Label
} from "reactstrap"
import { Link } from "react-router-dom"
import { BaseUrl } from "../../helpers/Baseurl"
import { AvForm, AvField } from "availity-reactstrap-validation";
import { createSlugfromName } from "../../helpers/methods";
import { isEmpty } from "lodash";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';


class Invoice extends Component {
  constructor(props) {
    super(props)
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj) {
      this.props.history.push('/logout')
    } else if (!validateToken(this.obj.access)) {
      this.props.history.push('/logout')
    }
    if (!has_Permission(this.obj.user, 7, 'read')) {
      this.props.history.push('/dashboard')
    }
    this.state = {
      invoice_id: "",
      alert_confirm: false,
      success_confirm: false,
      dynamic_title: "",
      dynamic_description: "",
      selectedInvoice: null,

      invoices: [],
      breadcrumbItems: [
        { title: "Itinerary Detail", link: `itinerary-detail/${this.props.match.params.id}` },
        { title: "Invoices", link: "#" },
      ],
    }

    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
    }

    this.handleInvoiceClicks = this.handleInvoiceClicks.bind(this)
    this.tog_edit_invoive = this.tog_edit_invoive.bind(this)
    this.handleInvoiceUpdate = this.handleInvoiceUpdate.bind(this)
  }
  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    this.props.history.push('/dashboard')
    toastr.error("Something Went Wrong", "")
  }

  async componentDidMount() {
    document.title = "Invoices | Planmans"
    this.loadData();
    this.loadItineraryData()
  }

  tog_edit_invoive() {
    this.setState({ bank_detail: [] })
    this.setState(prevState => ({
      model_edit_invoice: !prevState.model_edit_invoice
    }));
    this.removeBodyCss();
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  async loadItineraryData() {
    let id = this.props.match.params.id
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/itineraries/itineraries/${id}`, requestOptions)
      .then(res => res.json())
      .then(
        (data) => {
          this.setState({ itinerary: data })

        },

        (error) => {
          console.log(error, 'error--------------')
        }
      )
  }

  async loadData() {

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/invoices/invoices/?itinerary__id=${this.props.match.params.id}`, requestOptions)
      .then(res => {
        if (res.status >= 400) {
          res.json()
            .then(
              (data) => {

                console.log(data, "---data")
                toastr.error(data.detail, "")
              }
            )
        }
        else {
          res.json()
            .then(
              (data) => {
                this.setState({ invoices: data.results })
              }
            )
        }
      }
      )

  }
  handleInvoiceUpdate(e, values) {
    const { selectedInvoice } = this.state
    let data = values
    data['itinerary'] = this.props.match.params.id
    // data['transactions']= selectedInvoice.transactions
    console.log(data)

    const requestOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
    };
    fetch(`${BaseUrl}/api/invoices/invoices/${selectedInvoice.id}/`, requestOptions)
      .then(res => {
        if (res.status >= 400) {
          res.json()
            .then(
              (data) => {
                console.log(data, "---data")
                toastr.error("Something Went Wrong", "")
                this.setState({ loading: false })
              }

            )
        }
        else {
          toastr.success(`Invoice Updated Succesfully`, "")
          this.tog_edit_invoive()
          this.loadData()
          // this.props.history.push(`/invoices/${this.props.match.params.id}`)
        }
      }
      )

  }


  handleInvoiceClicks = id => {

    const requestOptions = {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${this.obj.access}` },

    };
    fetch(`${BaseUrl}/api/invoices/invoices/${id}/`, requestOptions)
      .then(res => {
        if (res.status >= 400) {
          console.log("error")
        }
        else {
          this.loadData();
          this.setState({
            invoice_id: "",
            success_confirm: true,
            alert_confirm: false,
            dynamic_title: "Deleted!",
            dynamic_description: "Invoice has been deleted."
          })
        }
      }
      )

  }

  render() {

    const { invoices, selectedInvoice } = this.state

    const { SearchBar } = Search

    //pagination customization
    let total_size = 1
    const pageOptions = {
      sizePerPage: 10,
      totalSize: total_size, // replace later with size(Order),
      custom: true,
    }

    const defaultSorted = [{
      dataField: 'id',
      order: 'asc'
    }];

    //Columns
    const BrandsColumns = [
      {
        dataField: "id",
        text: "Invoice",
        sort: true,
        // align: 'center'
      },
      {
        dataField: "name",
        text: "Name",
        formatter: (cellContent, row) => (
          has_Permission(this.obj.user, 7, 'edit') ?
            <Link to={`/invoice-preview/${row.id}`} className="me-3 text-dark">{row.name}</Link>
            : cellContent
        )
      },
      {
        dataField: "date",
        text: "Date",
        formatter: (cellContent, row) => (
          moment(row.date).format('DD-MM-YYYY')
        ),
        // align: 'center'
      },
      {
        dataField: "action",
        isDummyField: true,
        text: "Action",
        Style: { float: 'left' },
        formatter: (cellContent, row) => (
          <React.Fragment>
            {has_Permission(this.obj.user, 7, 'edit') ?
              <>
                <Link to={`/invoice-preview/${row.id}`} className="me-3 text-primary"><i className="mdi mdi-eye font-size-18"></i></Link>
                {/* <Link to={"#"} onClick={() => { this.tog_edit_invoive(); this.setState({ selectedInvoice: row }) }} className="me-3 text-warning"><i className="mdi mdi-pencil font-size-18"></i></Link> */}
              </>
              : null}{" "}
            {has_Permission(this.obj.user, 7, 'delete') ?
              <Link to="#" onClick={() => this.setState({ alert_confirm: true, invoice_id: row.id })} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
              : null}
          </React.Fragment>
        ),
      },
    ]

    return (

      <React.Fragment>
        <div className="page-content">

          <Container fluid>
            <Breadcrumbs title="" breadcrumbItems={this.state.breadcrumbItems} />
            {!isEmpty(this.state.itinerary) ? (
              <>
              
                <Row>
                  <div className="timeline-block my-3">
                    <div className="time-show-btn mt-0">

                      {has_Permission(this.obj.user, 1, 'edit') ?
                        <Link to={`/itinerary-detail/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className="fas fa-clipboard-list font-size-15"></i> Itinerary Detail</Link>
                        : null
                      }
                      

                      {has_Permission(this.obj.user, 0, 'edit') ?
                        <Link to={`/itinerary-daily-plan/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className="fas fa-clipboard-list font-size-15"></i> Itinerary Plan</Link>
                        : null
                      }
                      {has_Permission(this.obj.user, 7, 'read') ?
                        <Link to={`/itinerary-payment-detail/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className="fas fa-rupee-sign font-size-15"></i> Payments</Link>
                        : null
                      }
                      {has_Permission(this.obj.user, 1, 'edit') ?
                        <Link to={`/itinerary-terms-&-condition/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className=" far fa-list-alt font-size-15"></i> Terms & Conditions</Link>
                        : null}
                      <Link to={`/itinerary/${this.state.itinerary.id}/${createSlugfromName(this.state.itinerary.name)}`} target="_blank" className="btn btn-link btn-rounded w-lg"><i className="far fa-eye font-size-15"></i> View Itinerary</Link>

                    </div>
                  </div>
                </Row>
                <Row>
                  <Col xs="12">
                    <Card>
                      <CardBody>
                        <PaginationProvider
                          pagination={paginationFactory(pageOptions)}
                          data={invoices}
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider
                              keyField="id"
                              data={invoices}
                              columns={BrandsColumns}
                              bootstrap4
                              search
                            >

                              {toolkitProps => (
                                <React.Fragment>
                                  {invoices.length === 0?
                                  <Row className="mb-2">
                                    <Col sm="4">
                                      <div className="search-box me-2 mb-2 d-inline-block">
                                        <div className="position-relative">
                                          <SearchBar
                                            {...toolkitProps.searchProps}
                                          />
                                          <i className="bx bx-search-alt search-icon" />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col sm="8">
                                      <div className="text-sm-end">
                                        {has_Permission(this.obj.user, 7, 'create') ?
                                          <Button
                                            type="button"
                                            color="success"
                                            className="btn-rounded mb-2 me-2"
                                            onClick={() => this.props.history.push(`/new-invoice/${this.props.match.params.id}`)}
                                          >
                                            <i className="mdi mdi-plus me-1" />{" "}
                                            Add New Invoice
                                          </Button>
                                          : null}
                                      </div>
                                    </Col>
                                  </Row>:null}
                                  <div className="table-responsive">

                                    <BootstrapTable
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                      responsive
                                      bordered={false}
                                      striped={false}
                                      defaultSorted={defaultSorted}
                                      headerWrapperClasses={"table-light"}
                                    />

                                  </div>
                                  {/* <div className="pagination pagination-rounded justify-content-end mb-2">
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </div> */}
                                  {this.state.alert_confirm ? (
                                    <SweetAlert
                                      title="Are you sure?"
                                      warning
                                      showCancel
                                      confirmBtnBsStyle="success"
                                      cancelBtnBsStyle="danger"
                                      onConfirm={() => this.handleInvoiceClicks(this.state.invoice_id)}
                                      onCancel={() =>
                                        this.setState({
                                          alert_confirm: false,
                                          invoice_id: "",

                                        })
                                      }
                                    >
                                      You won't be able to revert this!
                                    </SweetAlert>
                                  ) : null}

                                  {this.state.success_confirm ? (
                                    <SweetAlert
                                      success
                                      title={this.state.dynamic_title}
                                      confirmBtnBsStyle="success"
                                      cancelBtnBsStyle="danger"
                                      onConfirm={() => this.setState({ success_confirm: false, alert_confirm: false })}
                                    >
                                      {this.state.dynamic_description}
                                    </SweetAlert>
                                  )
                                    : null
                                  }
                                </React.Fragment>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>) :
              (
                <div className="d-flex align-items-center justify-content-center min-vh-100">
                  <Spinner type="grow" className="me-2" color="secondary" />
                  <Spinner type="grow" className="me-2" color="secondary" />
                  <Spinner type="grow" className="me-2" color="secondary" />
                  <Spinner type="grow" className="me-2" color="secondary" />
                </div>
              )}

            <Col sm={6} md={4} xl={3} className="mt-4">

              <Modal
                isOpen={this.state.model_edit_invoice}
                toggle={this.tog_edit_invoive}
                centered={true}
              >
                <ModalHeader toggle={this.tog_edit_invoive}>
                  Edit {selectedInvoice?.name} Invoice
                </ModalHeader>
                <ModalBody>
                  <AvForm className="needs-validation" onValidSubmit={this.handleInvoiceUpdate} >
                    <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="name">Name</Label>
                          <AvField
                            name="name"
                            type="text"
                            value={selectedInvoice?.name}
                            errorMessage="Enter Name"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="name"


                          />
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="email">Email</Label>
                          <AvField
                            name="email"
                            type="email"
                            value={selectedInvoice?.email}
                            errorMessage="Enter Name"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="email"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="address">Address</Label>
                          <AvField
                            name="address"
                            type="text"
                            value={selectedInvoice?.address}
                            errorMessage="Enter Address"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="address"


                          />
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="phone">Phone</Label>
                          <AvField
                            name="phone"
                            placeholder="Phone"
                            type="text"
                            value={selectedInvoice?.phone}
                            errorMessage="Enter Phone"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="phone"
                          />

                        </div>
                      </Col>
                    </Row>
                    <Row>

                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="date">Invoice Date</Label>
                          <AvField
                            name="date"
                            type="date"
                            value={selectedInvoice?.date}
                            errorMessage="Select Date"
                            validate={{
                              required: { value: true },
                            }}
                            id="date"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>


                    </Row>


                    <FormGroup className="mb-0 mt-3">
                      {this.state.editdebitloading ? (
                        <Spinner className="me-2 mt-2" color="primary" />
                      ) : (
                        <div>

                          <Button type="submit" color="primary" className="me-1">
                            Submit
                          </Button>
                        </div>
                      )}
                    </FormGroup>
                  </AvForm>

                </ModalBody>
              </Modal>
            </Col>

          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default Invoice